<template>
  <div class="maps">
    <div class="heard">
      <div class="img">
        <img src="../../../assets/dapingImg/logo.png" alt />
          <div class="name">{{tenantName}}</div>
      </div>
      <div class="title">海运业务</div>
      <div class="date">
        <span>{{ nowDate + ' ' + nowWeek }}</span>
      </div>
    </div>
    <div class="container">
      <el-row :gutter="20">
        <!-- 左侧 -->
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <div class="left_one">
               <div class="left_h">
                  <span class="span_one">船运单状态</span>
                </div>
                <div class="left_table" id="CQZTpie" style=" height: 41vh;">
                </div>
               <!-- <el-carousel height="50vh"  indicator-position="none"   :interval="10000"  :autoplay="true">
                  <el-carousel-item kye='1'>
                    <div class="left_h">
                      <span class="span_one">船运单状态</span>
                    </div>
                    <div class="left_table"  id="SYZTpie" style=" height: 41vh;">
                    </div>
                  </el-carousel-item>
                  <el-carousel-item kye='2'>
                    <div class="left_h">
                      <span class="span_one">船运单状态</span>
                    </div>
                    <div class="left_table" id="CQZTpie" style=" height: 41vh;">
                    </div>
                  </el-carousel-item>
                </el-carousel> -->
            </div>
            <div class="left_two">
               <div class="left_h">
                  <span class="span_one">业务趋势</span>
              </div>
              <div id="YWQSzhe" style="height:40vh"></div>
            </div>
          </div>
        </el-col>
        <!-- 中间 -->
        <el-col :span="12" style="height:91vh">
          <div class="mapBox" >
            <div class="mapTop">历史海运总量：<span style="font-size:28px">{{totalData}}</span>吨</div>
            <!-- <div class="mapTop">
              <div>历史海运总量：</div>
              <ul>
                <li v-for="(item,index) in totalData.dataArr" :key="index">{{item}}</li>
              </ul>
              <div>吨</div>
            </div> -->
            <div class="map" id="map"></div>
            <!-- <div  class="SGSJzhuBox left_one">
                <div class="left_h">
                  <span class="span_one">疏港数据</span>
                  <span class="span_two">单位(吨)</span>
              </div>
              <div id="SGSJzhu" style="height:calc(30vh - 30px);"></div>
            </div> -->
          </div>
        </el-col>
        <!-- 右侧 -->
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <!-- <div class="left_one  left_main" style=" height: 31vh;">
              <div class="left_h">
                <span class="span_one">疏港数据统计</span>
              </div>
              <div class="stock" >
                  <ul>
                    <li>
                      <b class="b_r">{{totalData.wareWeight}}</b>
                      <br />
                      <span>历史入库量</span>
                    </li>
                    <li>
                      <b class="b_c">{{totalData.trafficWeight}}</b>
                      <br />
                      <span>历史汽运量</span>
                    </li>
                  </ul>
                  <ul>
                    <li>
                      <b class="b_r">{{totalData.inWeight}}</b>
                      <br />
                      <span>近七日入库量</span>
                    </li>
                    <li>
                      <b class="b_c">{{totalData.traWeight}}</b>
                      <br />
                      <span>近七日汽运量</span>
                    </li>
                  </ul>
              </div>
            </div> -->
            <div class="left_two" style="height:91vh">
               <div class="left_h">
                  <span class="span_one">船运单据</span>
              </div>
              <div>
                 <div id="table">
                    <vue-seamless-scroll :data="orderData" :class-option="optionSingleHeightTime" class="seamless-warp">
                      <ul class="item">
                        <li class="dingdan" v-for="item in orderData"  :key="item.id">
                          <div class="itemA">
                            <div><p>船运状态： {{item.shipStatusName}}</p></div>
                            <div><p >发布者：{{item.createUserName}}</p></div>
                          </div>
                          <div class="itemA">
                            <div><p>船舶名称： {{item.shipName}}</p></div>
                            <div><p >航次号：{{item.shipDateNo}}</p></div>
                          </div>
                          <div class="itemB">
                            <p style="color:#fe4830">{{item.deliverAddressName}}</p>
                            <i class="fa fa-long-arrow-right" aria-hidden="true" style="color:#03faec;"></i>
                            <p style="color:#fbad00">{{item.receivingAddressName}}</p>
                          </div>
                            <div class="itemA">
                              <p>创建时间{{item.createTime |dateFormat}}</p>
                            </div>
                        </li>
                      </ul>
                    </vue-seamless-scroll>
                  </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import { yearWaterTransList, recordList, listTotal, waterStatusList, listTrans, addressList, codeDataList, getAllTenants } from '@/api/data-center-server'
export default {
  data () {
    return {
      nowDate: '', // 当前日期
      nowTime: '', // 当前时间
      nowWeek: '', // 当前星期
      nowTimer: null,
      mapTimer: null,
      orderData: [],
      totalData: {},
      tenantName: ''
    }
  },
  created () {
    this.getDate()
    this.nowTimer = setInterval(this.getDate, 500)
  },
  mounted () {
    let that = this
    getAllTenants({}).then(res => {
      if (res.length == 0) {
        this.$alert('该租户下没有海运业务', '系统提示')
      } else if (res.length == 1) {
        that.tenantName = res[0].tenantName
        run(res[0].tenantCode)
        this.mapTimer = setInterval(() => {
          run(res[0].tenantCode)
        }, 1000 * 60 * 60)
      } else {
        that.tenantName = res[0].tenantName
        run(res[0].tenantCode)
        let n = 0
        this.mapTimer = setInterval(() => {
          n++
          if (n == res.length) {
            n = 0
          }
          that.tenantName = res[n].tenantName
          run(res[n].tenantCode)
        }, 15000)
      }
      function run (code) {
        that.YWQSzheFn(code)
        that.getSYDJ(code)
        that.getTotalData(code)
        that.SGSJzhuFn(code)
        that.$nextTick(() => {
          that.peiFn(code)
        })
        that.getMap(code)
      }
    })
  },
  methods: {
    // 地图
    getMap (code) {
      let _this = this
      addressList({ tenantCode: code }).then(res => {
        let data = res
        codeDataList({ tenantCode: code }).then(res => {
          let shiArr = []
          let xuArr = []
          res.forEach(item => {
            let qidian = [[item.sendAddress.longitude, item.sendAddress.latitude]]
            let zongdian = []
            if (item.receiveAddressList) {
              item.receiveAddressList.forEach(item1 => {
                zongdian.push([item1.longitude, item1.latitude])
              })

              if (item.shipCoordinateList) { // 有坐标点
                if (item.receiveAddressList.length == 1) { // 只有一个目的港
                  let zuobiao = []
                  item.shipCoordinateList.forEach(item2 => {
                    zuobiao.push([item2.longitude, item2.latitude])
                  })
                  shiArr.push(qidian.concat(zuobiao).concat(zongdian))
                } else { // 有两个目的港
                  let zuobiao = []
                  let latitude = zongdian[0][1]
                  item.shipCoordinateList.forEach(item2 => {
                    if (latitude > item2.latitude) {
                      zuobiao.push(zongdian[0])
                      zuobiao.push([item2.longitude, item2.latitude])
                    } else {
                      zuobiao.push([item2.longitude, item2.latitude])
                    }
                  })
                  if (zuobiao.length == item.shipCoordinateList.length) { // 目的港1没有插到坐标点里
                    shiArr.push(qidian.concat(zuobiao).concat(zongdian))
                  } else {
                    zuobiao.push(zongdian[1])
                    console.log(zuobiao)
                    shiArr.push(qidian.concat(zuobiao))
                  }
                }
              } else {
                shiArr.push(qidian.concat(zongdian))
              }
            }
          })
          map(data, shiArr, xuArr)
        })
      })
      function map (res, shiArr, xuArr) {
        // 初始化echarts实例
        let myChart = _this.$echarts.init(document.getElementById('map'))
        // 图标
        let iconMT = 'image://data:image/png;base64,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'
        let iconCK = 'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQ1IDc5LjE2MzQ5OSwgMjAxOC8wOC8xMy0xNjo0MDoyMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTkgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjlGNTMyRjVFODBBNjExRUJBN0ZDRjE0NTA2RUFBODc5IiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjlGNTMyRjVGODBBNjExRUJBN0ZDRjE0NTA2RUFBODc5Ij4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6OUY1MzJGNUM4MEE2MTFFQkE3RkNGMTQ1MDZFQUE4NzkiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6OUY1MzJGNUQ4MEE2MTFFQkE3RkNGMTQ1MDZFQUE4NzkiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz52aJo4AAAKO0lEQVR42uxde2wUxxn/Zm/v7Nh58IixY7CtJKp9FlIcIoIhLY0bRQKpJo9GpmqKqSoaReGPKgK1ppSqVKQJF6lR/kghiYKSBoQUrrRNcNUiVakpoomrypWRKsBRhWwnCOJEpKV28D12Ot/ekoJlfHO3r5nb7yet73TenZn9fr/9Zr7ZeTDOORCiC4NMQAIgkAAIJAACCYBAAiCQAAhRglnsBMaYljc22gzzpyyzgxmxuxiHuziDVgBeK/4180BMXnuwSXHNiLjmJLfyJ2uM3HDLGFzU0Q7F+nlY0RM0EMDfG6HmJtO8B1isU9zPavHTPeJo8jibcXEMCXscB54fvJTLDS0/B1MkgJBwaonZZTDWLZ5SQTb7svgpEXARMsK8J4SnGLI472//MDdAAvAZHzRAnRWP94gS94iCdSlm6QFhqbSRzaa/dB4mSABePu0t5ipmsQ1QIL5OcZ+L5Ke5wQ+0j+beIwG4wOmmqoc44xtFCR7TsgEGcJhx9mZyfPodEkApxLfEN4mPXuDs/oqItRg/Jv7uT45m95EA5iTe/Bpwo098XVOhYfdRYFYqOZr7MwngKgzfCYsSuXifcJdbotD5Iqq1FzJmNtXxL/g48gI43ZzYAAx+IirMVogSGIyIe96VHMsciKwABPm7xUcfRBspIYJtkRLAqcVVrUaM/0Lk3A0E4Qyg38qzre0fTY8ELYDAXwadaUk8ymL8j0T+NeFiN9oEbRN8gBKgBzjdFH9KJLiHKJ/zkd2cHM/urTgPcKY58VMiX+aRZHtsWwUEIyjyhQ53ErvSVcLOoERgEPnRFoGvbYAzzfFeDuxNotNNhMA3to1l92sXBooYv0d8HCIKPcH65FgmrU0jkMj3HIccm6rfBnBiWSLfBxH40U/gaRWAPXzYoSG+3k58+YKzPM/WltJjGGgVgN27RL6vuN2xsXpVAL7Yoe7dQMLDbuclmjpVgP1KF2A/0RMoemVeJfseBuJgjqpc4njk3ueH30EwMm1mVhcbVOJ7GwBH8hD5odQFrbbtw6wCnDF87xIbYXoC64G5xhj66wEKAzi1xQ3L77MPvT2BOw7KFoAzdFvb0bs3P/o4NO45aB/4XWOscbgIPAzs1dViC7+/HW578XUw62+zD/yOv+kcEQTaBsAZO+LKt3WzUmzhrVC37Vm4Zf13Zv3/vw/9CiZ2b4f8p59oWBWwh2ebgeRLGwCna+lmn+q774XGXx68LvkI/B+eg+fqx395nJTsAeyJmtz4q07GuWldDyza8TyYDY1S5+fOn4OPn/khXDqS1kwE1n0zJ6R67gGcWbraYMHmH0DjSwekyUfguXgNXqtXRFg6NyV5AJyfn4/H/6n8FG1U9s3zoO5HP4d5j3/PVTqfHXwNJp77MVj/+UwDF8AnYtns0qvXJ/DUA+DiDDqQX7X0blj86luuyUdgGpgWpqm+C2D2Ahq+hYH2yhyK48a1j8CSN96GmlVdnqWJaWGamLbyTqBEjqQFgGvyKLcsywzMf+JpWPzKW2AuavA8bUwT08Y8FPcCXTZXnnuAGFunbH1fUwv1z74kWvop3/PCPDAvzFPdDg95rqQFIEK/FUrW921LYfHrv4N5334isDwxL8wT81bSCZTAlVQUMFwPtYmqxEURD8SVqu8f/Do0pPZC7Nb6UPLPf3IBzvc9Bf/90+9VawdkM9OZ+R0XYNKTKKCqurpTNfIXYH2/7zehkW97WpE3lmGBYu0C5Ao586wK4Ja1UpmbiyegfvceqAugvpcFlgXLhGVTxgtIciYlAFELdKpwU4k7WqHp4B9g3rc2gWrAMmHZsIxqBAPgnQcQWKZCfd/863fhhhVfUbbxjWXDMmJZFcAyTwSAq26D9wsvl1bfP7mlUN8vVL4T0i6j3S54MvQFz5oc7twJAJdcD9OPNTz/MtRtfw50A5YZyw4hrrQqw11RAeB6+2HV9+hOb/nmd0FXYNnxHsJqF8hwV1wAHEIRAHa9aj9gEwoDT/3ompYSgAR3RQVQ2GmDoCNkuJOIAngtmVJbCdR6IAAgAegLEgAJgARAAiABkADcCIBQwZARwCSZSVtMkgBIACQAEgAJgARQvgAYCUBbFOeu+O7hhV20V6t0W1PvHYNPX3xGKVMvfHoH1KxSa5tD5M61AHALdRW1PfX+X9QSgII2kuGu+NtAK6+kAAgSApDgrqgAaozcMJlST8hwV1QALWNwUXyMkzm1w7jDneswEDFE9tQOUpxJzgtgx8memgWAkpyZUqnx/KAu741qVn7VVfTg9np1WoDImUcCuJTLDd1oJjLia0J5AYhYHGPy2YB9B0UF4PJ6RZBBzjyrApafgykhqRPkWLUJAE8UOPNIAHadwqkhqE39XwJXpuyJFuf9omGxVWfDoGu/nnuvJCBXsudKe4D2D3MDwPkAPV+qe38+YHPltQBs1wKQJgsr7v5L5KgkARjZbBoXIyQzK/v0T9gc+SUAZwVK8gLqIn31KqGeC8AWmcEPkJ0VdQBlcFOyAHA1ag5wmMytGPmCk5krhfsigEKcSVvCqxf7l8dJWQKwd6Zg/BiZXRn2j822W4hvAnBAO4Wqg7K5MMu9MDma3efsae/bzmHlDvwMY8Do54PH7SMEHEUuyncetHGk5u4/xI0jMWPO+AvEQkgtf2H7ucj3uw1gI2NmU7iRMdER9JMPI7btXcK1AOzdqznsIkYCD/x3Fds5PBAB2FVBYR/7FLESGFKOzT2IIF00AmfiTHPiiEitm/jx0/NDf9tYRnpHEH93D58BK28PGDlLNPmGs46NPYOnAmj/aHpEOIytxJNPT7+wLdpYWQEg2kYzvxV+ZzPR5XWjj2+2besxfBnsnxzP7hV11U5izbN6fyfa1I+0fZvtIRoqPyMReEM+2tKv9H2d7kMiUJt8z8PA64eH8V4ONIagNPL5xraxrOs3rkX5DUIACOfN4SGiVgrrk2MZT8ZeBtoPMGfDsHBD64nb4MgPvQ0wmwiEQ/kGUGfRbDiLtgmS/MAFcKWfgOfZWuzSJM6/aOz1o038iPOVaATO0S7YLT76Is4/vtjZ5lfiyrQBrlMl4I33RnI8QeGee/0kX3kPcAXDd8KiRC7exzjbEgXucSQPDubw4n2+NmGgVJVQGGOIVcKaCuX+KDAr5XYYV8UK4P9CiG+yqwbO7q8I2gtzKPa7Gb0bKQF8IYSmqoeEu9woSvCYlq4e4DDO2Cl30kbkBXAFp1rMVcxiG8TXHlEgtXeQLkyfT+NEzXLm6pEA5sAHDVBnxeM9vCCELsWIH8DFGXB+fqlTtEkA5XiFJWYXxNg6xo0VHHinKGU8YPeeZcAGObP+Bnl+pJRlWUgAXoeR9VBbVV3dyS1rpShup/hpmTiaPM4G10v+hzDXIDOM96cvXx7suKD+biqREMBsGG2G+VOW2YFbqOMu2oWNlO29dGceiMlrDzbpbJRxEpdcx1W3ZRZerkgBECobtHEkCYBAAiCQAAgkAAIJgEACIEQK/xNgAIJlOwIaypzgAAAAAElFTkSuQmCC'
        let iconC = 'image://data:image/png;base64,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'
        let chartOption = {
          color: ['#fdfd01'],
          tooltip: {
            // 鼠标移到图里面的浮动提示框
            // formatter详细配置： https://echarts.baidu.com/option.html#tooltip.formatter
            formatter (params, ticket, callback) {
              let htmlStr = `
                <div style='font-size:18px;'> ${params.name}</div>
              `
              return htmlStr
            }
          },
          // backgroundColor:"#ff7f50",//提示标签背景颜色
          //
          // 图例
          legend: {
            orient: 'vertical',
            id: 1,
            y: 'top',
            x: 'right',
            itemWidth: 15,
            data: [
              {
                name: '码头'
                // icon: iconMT
              },
              {
                name: '仓库',
                icon: iconCK
              }
            ],
            textStyle: {
              color: '#fff'
            }
          },
          geo: {
          // 地理坐标系组件用于地图的绘制
            map: 'china', // 表示中国地图
            roam: false, // 是否开启鼠标缩放和平移漫游
            zoom: 2.1, // 当前视角的缩放比例（地图的放大比例）
            center: [117.232389, 31.311958],
            scaleLimit: { // 滚轮缩放的极限控制
              min: 1
            },
            label: {
              show: true,
              color: '#03faec'
            },
            itemStyle: {
            // 地图区域的多边形 图形样式。
              borderColor: 'rgba(0, 0, 0, 0.2)',
              normal: {
                areaColor: '#01145D', // 区域背景色 地图
                borderColor: '#03DBD9' // 每个区域的边框色
              },
              emphasis: {
                areaColor: '#02229b' // 区域背景色 点击后颜色
              }
            },
            emphasis: {
              label: {
                color: '#00FFFF'
              }
            }
          },
          series: [
            // 码头坐标
            {
              name: '码头',
              type: 'scatter',
              coordinateSystem: 'geo',
              data: res.matou,
              // symbol: iconMT,
              // symbolSize: 26,
              label: {
                normal: {
                  show: true,
                  formatter: function (params) {
                    if (params.data.isUsed == 1) {
                      return ''
                    } else {
                      return params.name
                    }
                  },
                  position: 'bottom',
                  color: '#fff',
                  fontSize: '11'
                },
                emphasis: {
                  show: false,
                  color: '#00d5e9'
                }
              }
            },
            // 仓坐标
            {
              name: '仓库',
              type: 'scatter',
              coordinateSystem: 'geo',
              data: res.cangku,
              symbol: iconCK,
              symbolSize: 26,
              label: {
                normal: {
                  show: true,
                  formatter: function (params) {
                    if (params.data.isUsed == 1) {
                      return ''
                    } else {
                      return params.name
                    }
                  },
                  position: 'bottom',
                  color: '#fff',
                  fontSize: '11'
                },
                emphasis: {
                  show: false,
                  color: '#00d5e9'
                }
              }
            },
            { // 地图线的动画效果
              type: 'lines',
              zlevel: 2,
              effect: {
                show: true,
                period: 8, // 箭头指向速度，值越小速度越快
                trailLength: 0.1, // 特效尾迹长度[0,1]值越大，尾迹越长重
                symbol: 'path://M30.9,53.2C16.8,53.2,5.3,41.7,5.3,27.6S16.8,2,30.9,2C45,2,56.4,13.5,56.4,27.6S45,53.2,30.9,53.2z M30.9,3.5C17.6,3.5,6.8,14.4,6.8,27.6c0,13.3,10.8,24.1,24.101,24.1C44.2,51.7,55,40.9,55,27.6C54.9,14.4,44.1,3.5,30.9,3.5z M36.9,35.8c0,0.601-0.4,1-0.9,1h-1.3c-0.5,0-0.9-0.399-0.9-1V19.5c0-0.6,0.4-1,0.9-1H36c0.5,0,0.9,0.4,0.9,1V35.8z M27.8,35.8 c0,0.601-0.4,1-0.9,1h-1.3c-0.5,0-0.9-0.399-0.9-1V19.5c0-0.6,0.4-1,0.9-1H27c0.5,0,0.9,0.4,0.9,1L27.8,35.8L27.8,35.8z',
                symbolSize: 9 // 图标大小
              },
              lineStyle: {
                normal: {
                  color: '#1DE9B6',
                  width: 1, // 线条宽度
                  opacity: 1, // 尾迹线条透明度
                  curveness: 0.3 // 尾迹线条曲直度
                }
              },
              polyline: true,
              data: shiArr
            },
            { // 地图线的动画效果
              type: 'lines',
              zlevel: 2,
              effect: {
                show: true,
                period: 8, // 箭头指向速度，值越小速度越快
                trailLength: 0.1, // 特效尾迹长度[0,1]值越大，尾迹越长重
                symbol: 'path://M30.9,53.2C16.8,53.2,5.3,41.7,5.3,27.6S16.8,2,30.9,2C45,2,56.4,13.5,56.4,27.6S45,53.2,30.9,53.2z M30.9,3.5C17.6,3.5,6.8,14.4,6.8,27.6c0,13.3,10.8,24.1,24.101,24.1C44.2,51.7,55,40.9,55,27.6C54.9,14.4,44.1,3.5,30.9,3.5z M36.9,35.8c0,0.601-0.4,1-0.9,1h-1.3c-0.5,0-0.9-0.399-0.9-1V19.5c0-0.6,0.4-1,0.9-1H36c0.5,0,0.9,0.4,0.9,1V35.8z M27.8,35.8 c0,0.601-0.4,1-0.9,1h-1.3c-0.5,0-0.9-0.399-0.9-1V19.5c0-0.6,0.4-1,0.9-1H27c0.5,0,0.9,0.4,0.9,1L27.8,35.8L27.8,35.8z',
                symbolSize: 9 // 图标大小
              },
              lineStyle: {
                normal: {
                  color: 'rgb(254, 72, 48)',
                  width: 1, // 线条宽度
                  opacity: 1, // 尾迹线条透明度
                  curveness: 0.3, // 尾迹线条曲直度
                  type: 'dashed'
                }
              },
              polyline: true,
              data: xuArr
            }
          ]
        }
        myChart.setOption(chartOption)
      }
    },
    // 疏港统计
    SGSJzhuFn (code) {
      listTrans({ tenantCode: code }).then(res => {
        // 柱状图数据
        var map4Data1 = []
        var map4Data2 = []
        this.nameData = []
        res.forEach((item, index) => {
          this.nameData.push(item.transportDate)
          map4Data1.push(item.storageWeight)
          map4Data2.push(item.trafficWeight)
        })
        let myChart = this.$echarts.init(document.getElementById('SGSJzhu'))

        // 绘制图表--柱状
        myChart.setOption({
          color: ['#0DD9FE', '#52F23A'],
          // backgroundColor: "#323a5e",
          grid: {
            left: '2%',
            right: '4%',
            bottom: '9%',
            top: '25%',
            containLabel: true
          },
          legend: {
            icon: 'circle',
            data: ['入库量', '汽运量'],
            textStyle: {
              color: '#fff'
            }
          },
          // ---  提示框 ----
          tooltip: {
            show: true, // 是否显示提示框，默认为true
            trigger: 'item', // 数据项图形触发
            axisPointer: {
              // 指示样式
              type: 'shadow',
              axis: 'auto'
            },
            formatter: function (value) {
              return value.marker + value.seriesName + '：' + value.value
            },
            padding: 5,
            textStyle: {
              // 提示框内容的样式
              color: '#fff'
            }
          },
          calculable: true,
          xAxis: {
            type: 'category',
            data: this.nameData,
            axisLine: {
              lineStyle: {
                color: 'white'
              }
            },
            axisLabel: {
              // interval: 0,
              // rotate: 40,
              textStyle: {
                fontFamily: 'Microsoft YaHei'
              }
            }
          },
          yAxis: {
            type: 'value',
            data: ['2000', '4000', '6000', '8000'],
            axisLine: {
              show: false,
              lineStyle: {
                color: 'white'
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: 'rgba(255,255,255,0.3)'
              }
            },
            axisLabel: {}
          },
          series: [
            {
              name: '入库量',
              type: 'bar',
              barGap: 0,
              barWidth: '15%',
              data: map4Data1
            },
            {
              name: '汽运量',
              type: 'bar',
              barGap: 0,
              barWidth: '15%',
              data: map4Data2
            }
          ]
        })
      })
        .catch(err => {
          console.log(err)
        })
    },
    // 船期水运状态
    peiFn (code) {
      let _this = this
      waterStatusList({ tenantCode: code }).then(res => {
        // pie(res.waterStatus, '水运单状态', 'SYZTpie')
        pie(res, '船期状态', 'CQZTpie')
      })
      function pie (data, name, id) {
        var img = 'data:image/png;base64,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'
        let idChart = _this.$echarts.init(document.getElementById(id))
        var dataArr = []
        var color = ['#00ffff', '#00cfff', '#006ced', '#ffe000', '#ffa800', '#ff5b00', '#ff3000', '#00ffff']
        for (var i = 0; i < data.length; i++) {
          dataArr.push({
            value: data[i].statusCount,
            name: data[i].shipStatusName,
            itemStyle: {
              normal: {
                borderWidth: 5,
                shadowBlur: 20,
                borderColor: color[i],
                shadowColor: color[i]
              }
            }
          }, {
            value: 1,
            name: '',
            itemStyle: {
              normal: {
                label: {
                  show: false
                },
                labelLine: {
                  show: false
                },
                color: 'rgba(0, 0, 0, 0)',
                borderColor: 'rgba(0, 0, 0, 0)',
                borderWidth: 0
              }
            }
          })
        }
        var seriesOption = [{
          name: '',
          type: 'pie',
          clockWise: false,
          radius: [70, 75],
          hoverAnimation: false,
          itemStyle: {
            normal: {
              label: {
                show: true,
                position: 'outside',
                color: '#ddd',
                formatter: function (params) {
                  if (params.name) {
                    return params.name + ':' + params.value
                  }
                }
              }
            }
          },
          data: dataArr
        }]
        var option = {
          backgroundColor: 'rgba(225,225,225,0)',
          color: color,
          title: {
            text: name,
            top: '48%',
            textAlign: 'center',
            left: '49%',
            textStyle: {
              color: '#fff',
              fontSize: 18,
              fontWeight: '400'
            }
          },
          graphic: {
            elements: [{
              type: 'image',
              z: 3,
              style: {
                image: img,
                width: 128,
                height: 128
              },
              left: 'center',
              top: 'center',
              position: [100, 100]
            }]
          },
          tooltip: {
            trigger: 'item',
            backgroundColor: 'rgba(0,0,0,0.5)',
            formatter: function (params) {
              var percent = 0
              var total = 0
              for (var i = 0; i < data.length; i++) {
                total += data[i].statusCount
              }
              if (total == 0) {
                percent = 0
              } else {
                percent = ((params.value / total) * 100).toFixed(0)
              }

              return params.marker + '<span style="color:' + params.color + '">' + params.data['name'] + '\n' + params.data['value'] + '</span></br>' + '占百分比：' + percent + '%'
            }
          },
          legend: {
            show: false
          },
          toolbox: {
            show: false
          },
          series: seriesOption
        }
        idChart.setOption(option)
      }
    },
    // 疏港数据
    getTotalData (code) {
      let that = this
      listTotal({ tenantCode: code }).then(res => {
        this.totalData = res
        // let str=Math.round(res.historyTotal)+''
        // that.totalData.dataArr=str.split('');
        // for(var i=0;i<9;i++){
        //   if(that.totalData.dataArr.length<9){
        //     that.totalData.dataArr.unshift(0)
        //   }
        // }
      })
    },
    // 水运单据
    getSYDJ (code) {
      recordList({ tenantCode: code }).then(res => {
        this.orderData = res.list
      })
    },
    // 业务趋势
    YWQSzheFn (code) {
      yearWaterTransList({ tenantCode: code }).then(res => {
        zhe(res)
      })
      let _this = this
      function zhe (data) {
        let SYdata = []
        let CQdata = []
        let DateData = []
        data.forEach(item => {
          CQdata.push({ value: item.shipDateCount, weight: item.monthWeight })
          DateData.push(item.createMonth)
        })
        let idChart = _this.$echarts.init(document.getElementById('YWQSzhe'))
        // 绘制图表--折线图
        var idChartOption = {
          tooltip: {
            trigger: 'axis',
            formatter: function (value) {
              return '数量:' + value[0].data.value + '艘<br/>重量:' + value[0].data.weight + '吨'
            }
          },
          legend: {
            data: ['船期'],
            color: ['#fff'],
            textStyle: {
              color: '#fff'
            }
          },
          grid: {
            left: '6%',
            right: '8%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            data: DateData,
            // 横坐标轴颜色
            axisLine: {
              lineStyle: {
                color: '#14D5FF'
              }
            }
          },
          yAxis: {
            type: 'value',
            // 横坐标轴颜色
            axisLine: {
              lineStyle: {
                color: '#14D5FF'
              }
            },
            splitLine: {
              lineStyle: {
                color: '#14D5FF'
              }
            }
          },
          series: [
            {
              name: '船期',
              type: 'line',
              color: '#3BE232',
              data: CQdata
            }
          ]
        }
        idChart.setOption(idChartOption)
      }
    },
    // 获取当前时间
    getDate: function () {
      var _this = this
      let yy = new Date().getFullYear()
      let mm = new Date().getMonth() + 1
      let dd = new Date().getDate()
      let week = new Date().getDay()
      let hh = new Date().getHours()
      let mf =
        new Date().getMinutes() < 10
          ? '0' + new Date().getMinutes()
          : new Date().getMinutes()
      if (week == 1) {
        this.nowWeek = '星期一'
      } else if (week == 2) {
        this.nowWeek = '星期二'
      } else if (week == 3) {
        this.nowWeek = '星期三'
      } else if (week == 4) {
        this.nowWeek = '星期四'
      } else if (week == 5) {
        this.nowWeek = '星期五'
      } else if (week == 6) {
        this.nowWeek = '星期六'
      } else {
        this.nowWeek = '星期日'
      }
      _this.nowTime = hh + ':' + mf
      _this.nowDate = yy + '/' + mm + '/' + dd
    }
  },
  computed: {
    optionSingleHeightTime () {
      return {
        // singleHeight: 26,
        // waitTime: 2500,
        step: 0.5, // 数值越大速度滚动越快
        limitMoveNum: this.orderData.length, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1200 // 单步运动停止的时间(默认值1000ms)
      }
    }
  },
  filters: {
    statusFormat: function (value) {
      switch (value) {
        case 1001:
          return '待装船'
        case 1002:
          return '装船中'
        case 1003:
          return '装船完成'
        case 2001:
          return '运输中'
        case 2002:
          return '已到港'
        case 3001:
          return '卸船中'
        case 3002:
          return '卸船完成'
      }
    }
  },
  destroyed () {
    clearInterval(this.nowTimer)
    clearInterval(this.mapTimer)
  }
}
</script>

<style lang="less" scoped>
.mapBox{
  height: 100%;
  position: relative;
  .map{
    width: 100%;
    height: 95vh;
  }
  .mapTop{
    width: 100%;
    text-align: center;
    color: #fff;
    position: absolute;
    top: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999999999;
    ul{
      display: flex;
      li{
        background: #244ad2;
        margin-right: 8px;
        padding: 6px 8px;
        font-size: 36px;
      }
    }
  }
  .SGSJzhuBox{
    position: absolute;
    bottom: 0px;
    width: 100%;
    height: 30vh;
  }
}
.heard {
  width: 100%;
  height: 6vh;
  line-height: 6vh;
  display: flex;
  background: url("../../../assets/dapingImg/标题光条.png") no-repeat;
  background-size: 100% 100%;
  text-align: center;
  .title {
    flex: 1;
    font-size: 30px;
    font-weight: 700;
    color: #03faec;
    margin-right: 60px;
  }
  .date {
    font-size: 16px;
    color: #ffdd17;
  }
   .img{
    height: 6vh;
    display: flex;
    .name{
      color: #03faec;
      margin-bottom: 20px;
      margin-left: 10px;
    }
    img{
      height: 100%;
    }
  }
}
.maps {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background:url('../../../assets/dapingImg/bg.png') 100%;

}
/*左右固定，中间自适应  利用绝对定位*/
.container {
  width: 100%;
  height: 91vh;
  position: relative;
  margin-top: 20px;
}
.left_two {
  //折线图
  // background-color: #ccc;
  padding: 0px 0px 0px 1px;
  box-sizing: border-box;
  height: 44vh;
  overflow: hidden;
  width: 100%;
  background: url("../../../assets/dapingImg/bg1.png") no-repeat;
  background-size: 100% 100%;
  // overflow-x: scroll;
}
.left_one {
  //轮播
  // background-color: #ccc;
  padding: 0px 0px 0px 1px;
  box-sizing: border-box;
  height: 45vh;
  margin-bottom: 10px;
  width: 100%;
  background: url("../../../assets/dapingImg/bg1.png") no-repeat;
  background-size: 100% 100%;

  // overflow-x: scroll;
}
.left_h {
  height: 30px;
  line-height: 30px;
  color: #03faec;
  // font-weight: 700;
  font-size: 20px;
  background: url("../../../assets/dapingImg/mk-title-bg.png") no-repeat;
  background-size: 100% 100%;
  .span_one {
    float: left;
    margin-left: 10px;
    font-size: 16px;
  }
  .span_two {
    float: right;
    margin: 5px;
    font-size: 16px;

    font-weight: normal;
  }
}
.left_main {
  text-align: center;
  .stock {
    width: 100%;
    font-size: 16px;
    height: calc(100% - 60px);
    ul {
      display: flex;
      height: 50%;
      align-items: center;
      li {
        width: 50%;
        text-align: center;
        margin: 0;
        padding: 0;
        // margin-left: 55px;
      }
      // 日入
      .b_r {
        font-size: 20px;
        color: #eed808;
      }
      // 日出
      .b_c {
        font-size: 20px;
        color: #4aec45;
      }
      span {
        color: #fff;
      }
    }
  }
}
.seamless-warp {
  overflow: hidden;
  ul {
   margin: 0;
   padding: 0;
// margin-top: 10px;
   color: #03faec;
   li{
      background:rgba(3, 250, 236, 0.2);
      padding:10px;
      font-size: 12px;
      margin-bottom: 10px;
   }
  }
  .yundan{
    display: flex;
    div{
      width: 50%;
      p{
         white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          word-break: break-all;
      }
    }
  }
  .itemA{
      p{
          margin: 0;
          margin-bottom: 10px;
      }
  }
  .dingdan{
    .itemA{
      display: flex;
      div{
        width: 50%;

      }
    }
    .itemB{
      font-size: 16px;
      display: flex;
      align-items: center;
       margin-bottom: 10px;
      p{
         white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          word-break: break-all;
        margin: 0;
      }
      .fa-long-arrow-right{
        margin: 0 10px;
      }
    }
  }
}
</style>
